if (!customElements.get('product-navigation')) {
    class ProductNavigation extends HTMLElement {
        constructor() {
            super();
            this.offsetEl = document.querySelector('.product-main + *');
            this.offsetElPaddingTop = this.offsetEl.style.paddingTop;
            this.addToCart = this.querySelector('button');
            this.list = this.querySelector('ul');
            this.navLinks = this.querySelectorAll('ul.product-navigation__list li a');
            this.formAddToCart = document.querySelector('form[action="/cart/add"] input[value="' + this.addToCart.dataset.productId + '"] + div button[type="submit"]');
            this.addListeners();
            this.updateBreakingPoint();
            this.handleScroll();
            this.duplicateForMobile();
            this.initSectionObserver();
        }

        addListeners() {
            window.addEventListener('scroll', this.handleScroll.bind(this));
            window.addEventListener('resize', this.updateBreakingPoint.bind(this));
            this.addToCart.addEventListener('click', this.handleAddToCart.bind(this));
            this.list.addEventListener('click', this.handleClickToScroll.bind(this));
        }

        handleClickToScroll(e) {
            e.preventDefault();
            const target = e.target.hash;

            window.scrollTo({
                behavior: 'smooth',
                top:
                    document.querySelector(target).getBoundingClientRect().top -
                    document.body.getBoundingClientRect().top -
                    this.offsetHeight,
            });
        }

        handleScroll() {
            if (window.scrollY > this.breakingPoint && !this.classList.contains('fixed')) {
                this.gapHeight = this.offsetHeight;
                this.classList.add('fixed');
                this.offsetEl.style.paddingTop = `${this.gapHeight}px`;

            } else if (window.scrollY <= this.breakingPoint && this.classList.contains('fixed')) {
                this.classList.remove('fixed');
                this.offsetEl.style.paddingTop = this.offsetElPaddingTop;
            }
        }

        handleAddToCart() {
            if (this.formAddToCart) {
                this.formAddToCart.click();
            }
        }

        updateBreakingPoint() {
            this.breakingPoint = this.offsetEl.offsetTop;
        }

        duplicateForMobile() {
            const clonedList = this.querySelector('.product-navigation__list').cloneNode(true);
            const targetContainer = document.querySelector('product-navigation-mobile');

            clonedList.className = 'product-navigation__list flex flex-col';

            if (targetContainer) {
                targetContainer.appendChild(clonedList);
            }
        }

        highlightNavLink(link) {
            this.navLinks.forEach(navLink => {
                navLink.classList.remove('highlight');
            });
            if (link) {
                link.classList.add('highlight');
            }
        }

        initSectionObserver() {
            const observer = new IntersectionObserver((entries) => {
                let isAnySectionIntersecting = false;

                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        isAnySectionIntersecting = true;
                        const activeSectionId = entry.target.id;
                        const activeNavLink = this.querySelector(`ul.product-navigation__list li a[href="#${activeSectionId}"]`);
                        this.highlightNavLink(activeNavLink);
                    }
                });

                if (!isAnySectionIntersecting) {
                    this.highlightNavLink(null);
                }
            }, { threshold: 0.5 });

            this.navLinks.forEach(link => {
                const href = link.getAttribute('href');
                if (href.startsWith('#')) {
                    const id = href.substring(1);
                    const section = document.getElementById(id);
                    if (section) {
                        observer.observe(section);
                    }
                }
            });
        }
    }

    customElements.define('product-navigation', ProductNavigation);
}